<template>
  <v-chip :color="color" :text-color="textColor">
    {{ text }}
  </v-chip>
</template>

<script>
import { delegationOrderStatusExtended } from "../../staticData/DelegationOrder";
export default {
  name: "DelegationOrderStatusChip",
  props: {
    status: {
      required: true
    }
  },
  computed: {
    color() {
      if (typeof delegationOrderStatusExtended().find(v => v.value === this.status) === "undefined") return null;
      return delegationOrderStatusExtended().find(v => v.value === this.status).color;
    },
    text() {
      if (typeof delegationOrderStatusExtended().find(v => v.value === this.status) === "undefined") return null;
      return delegationOrderStatusExtended().find(v => v.value === this.status).text;
    },
    textColor() {
      if (typeof delegationOrderStatusExtended().find(v => v.value === this.status) === "undefined") return null;
      return delegationOrderStatusExtended().find(v => v.value === this.status).textColor;
    }
  }
};
</script>

<style scoped></style>
